export const SET_OPP_LIST = "SET_OPP_LIST";
export const SET_OPP_TASK_LIST = "SET_OPP_TASK_LIST";
export const SET_OPP_STAGE_HISTORY = "SET_OPP_STAGE_HISTORY";
export const SET_OPP = "SET_OPP";
export const SET_OPP_STAGES_LIST = "SET_OPP_STAGES_LIST";
export const SET_OPP_TYPE_LIST = "SET_OPP_TYPE_LIST";
export const SET_OPP_SERVICE_CATEGORY_LIST = "SET_OPP_SERVICE_CATEGORY_LIST";
export const SET_OPP_COMMENTS = "SET_OPP_COMMENTS";
export const SET_OPP_QUOTE_INVOICE = "SET_OPP_QUOTE_INVOICE";
export const SET_OPP_DELIVERABLES_LIST = "SET_OPP_DELIVERABLES_LIST";
export const SET_OPP_DELIVERABLES = "SET_OPP_DELIVERABLES";
export const SET_OPP_STAGEWISE_COUNT = "SET_OPP_STAGEWISE_COUNT";
export const SET_OPP_STATUSWISE_COUNT = "SET_OPP_STATUSWISE_COUNT";
export const SET_OPP_TASK_LIST_FULL = "SET_OPP_TASK_LIST_FULL";
export const SET_OPP_TASK_DELIVERABLES = "SET_OPP_TASK_DELIVERABLES";
export const SET_OPP_COMMENTS_BY_ID = "SET_OPP_COMMENTS_BY_ID";
export const SET_OPP_STATUS_LIST = "SET_OPP_STATUS_LIST";
export const CLEAR_OPP = "CLEAR_OPP";
export const SET_OPPORTUNITY_BY_OPPID = "SET_OPPORTUNITY_BY_OPPID";
export const SET_OPP_ORDER_LIST = "SET_OPP_ORDER_LIST";
export const SET_OPP_INVOICE_REQUEST_LIST = "SET_OPP_INVOICE_REQUEST_LIST";
export const SET_OPP_DELIVERY_PENDING_LIST = "SET_OPP_DELIVERY_PENDING_LIST";
export const SET_OPP_DELIVERABLES_BY_TYPE = "SET_OPP_DELIVERABLES_BY_TYPE";
export const SET_OPPORTUNITY_SUMMARY = "SET_OPPORTUNITY_SUMMARY";
